import type { Manga } from "@/mocks/manga";
import MangaCard from "./MangaCard";

const gridClass: Record<number, string> = {
  2: "grid-cols-2",
  3: "grid-cols-2 sm:grid-cols-3",
  4: "grid-cols-2 sm:grid-cols-2 lg:grid-cols-4",
  5: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5",
  6: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6",
};

export default function MangaGrid({ items, cols = 6 }: { items: Manga[]; cols?: number }) {
  const cls = gridClass[cols] || gridClass[6];
  return (
    <div className={`grid gap-3 md:gap-4 ${cls}`}>
      {items.map((m) => (
        <MangaCard key={m.id} manga={m} />
      ))}
    </div>
  );
}